import { FiltroLista, IFiltroLista } from 'src/app/filter/filtro-lista';


export interface IFiltroListaEstimativaNegociacao extends IFiltroLista{

  CZACCDNGC: string;
  CZACFAZENDA: string;
  CZACDSCFAZ: string;
  CZACCLTORA: string;


}

export class FiltroListaEstimativaNegociacao extends FiltroLista {

  dados: IFiltroListaEstimativaNegociacao = this.setDefault();
  timeout = this.getDataString();

  public setDefault(): IFiltroListaEstimativaNegociacao {
    return {
      page: 1,
      pageSize: 20,
      filter: '',
      order: '',

      CZACCDNGC: '',
      CZACFAZENDA: '',
      CZACDSCFAZ: '',
      CZACCLTORA: '',

    };
  }

}
